import { render, staticRenderFns } from "./AllocateDialog.vue?vue&type=template&id=7d1fbe84&"
import script from "./AllocateDialog.vue?vue&type=script&lang=js&"
export * from "./AllocateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports